import ShareableLinkPage from './ShareableLinkPage.page';

export default ShareableLinkPage;
